 

import katex from "katex";
import { nanoid } from "nanoid";

/* eslint-disable default-case */
export const handleClickAway = (target, ids = []) => {
  if (target?.parentElement?.id === undefined) {
    return false;
  }
  if (ids.includes(target?.parentElement?.id)) {
    return true;
  }
  return handleClickAway(target?.parentElement, ids);
};

export const removeEvent = (event, handler) => {
  window.removeEventListener(event, handler);
};

export const toKeys = (obj = {}) => {
  return Object.keys(obj);
};

export const RGBAtoHEX = (rgba = "") => {
  const tupple = rgba.match(/\d+/g) ?? [];
  const [red, green, blue, alpha] = tupple.map((c) =>
    (0x0 + +c).toString(16).padStart(2, "0")
  );

  const hexColor = "#" + red + green + blue + (alpha || "ff");
  return hexColor;
};

export const colorParser = (color) => {
  switch (color?.length) {
    case 3:
      return color
        .split("")
        .map((c) => c.padStart(2, c))
        .join("")
        .toLowerCase();
    case 6:
      return (color + "ff").toLowerCase();
    default:
      return color;
  }
};

export const compareHexColor = (a, b) => {
  const color1 = colorParser(a.match(/[^#]+/g)?.[0]);
  const color2 = colorParser(b.match(/[^#]+/g)?.[0]);

  return color1 === color2;
};

export function toPx(magnitude, unit) {
  const constant = {
    px: 1,
    pt: 96 / 72,
    in: 96,
  };
  return +(magnitude * constant[unit]).toFixed(2) || 1;
}
export function isOverflown(parent) {
  const constraintHeight = +parent.attributes.dataheight.value;
  return (
    isNaN(constraintHeight) ||
    Math.round(constraintHeight) < Math.round(parent.scrollHeight)
  );
}
export const resizeText = (element, parent, unit = "px", gate = null) => {
  if (gate) {
    return;
  }
  let size = 5.67;
  const maxSize = 96;
  let overflow = false;
  while (!overflow && size < maxSize) {
    element.style.fontSize = `${size}${unit}`;
    overflow = isOverflown(parent);
    if (!overflow) size++;
  }
  element.style.fontSize = `${size - 1}${unit}`;
};

export const deleteById = (id, index, data) => {
  const data_ = [...data];
  for (const content of data) {
    console.log(data, content);
    if (content.id === id) {
      data_.splice(index, 1);
    }
  }
  return data_;
};

export const pushX = (data, array) => {
  const array_ = [...array];
  const isDuplicate = array_.some((obj) => obj.id === data.id);

  if (!isDuplicate) {
    array_.push(data);
  }
  return array_;
};

export const valueParser = (value) => {
  const valueStr = ("" + value).match(/^[0-9.]*/).toString();
  const unitStr = ("" + value).match(/[^0-9]*$/).toString() || "px";

  return valueStr + unitStr;
};

export const inputValidation = (value, type = "int") => {
  switch (type) {
    case "int": {
      if (typeof value !== "number" || isNaN(value)) {
        return false;
      }
      return true;
    }
  }
};

export function createIntersectionObserver(target, config, cb) {
  const observer = new IntersectionObserver(cb, config);

  if (typeof target === "object") {
    target.forEach((t) => {
      observer.observe(t, config);
    });
  } else {
    observer.observe(target, config);
  }

  return observer;
}

export function createMutationObserver(target, config, cb) {
  const observer = new MutationObserver(cb);

  if (target?.values?.()?.[Symbol?.toStringTag] === "Array Iterator") {
    target.forEach((t) => {
      observer.observe(t, config);
    });
  } else {
    observer.observe(target, config);
  }

  return observer;
}

export function parseTemplateData(data, key) {
  let content = ``;

  for (let c of data) {
    switch (c.type) {
      case "text": {
        if (c.text) {
          content += c[key] || c.text;
        }
        break;
      }
      case "math": {
        if (c.text) {
          content += `<span latexstring="${c.text}">${katex.renderToString(
            c.text,
            {
              throwOnError: false,
              output: "mathml",
            }
          )}</span>`;
        }
        break;
      }
    }
  }
  return content;
}

export function parseTemplateTextContent(html) {
  const __div = document.createElement("div");
  __div.innerHTML = html;
  return __div.textContent;
}

export function normalizeBase64Image(base64) {
  return base64?.startsWith("data")
    ? base64
    : `data:image/png;base64,${base64}`;
}

export function debounce(func, timeout = 200) {
  let timeRef;
  return (...args) => {
    clearTimeout(timeRef);
    timeRef = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

export function pageID(pos, context, size = 4) {
  const space = context?.trim() ? context.trim().slice(0, size) : nanoid(size);
  return `${pos - 1}:${space}:${pos + 1}`;
}
